import React from 'react';
import { AlertContent } from 'components';
import { theme } from 'design';

interface EnableTextNotificationsProps {
  onCancel?: () => void;
  onClose: () => void;
  onConfirm: () => void;
}

const EnableTextNotifications = ({ onCancel, onClose, onConfirm, ...rest }: EnableTextNotificationsProps) => {
  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <AlertContent
      icon="Message"
      iconFill={theme.color.success[50]}
      title="Enable text notifications?"
      message="By enabling text notifications you agree to receive automatic text alerts about your account. Standard messaging rates may apply."
      leftActionLabel="Cancel"
      onLeftAction={handleCancel}
      rightActionLabel="Enable"
      onRightAction={handleConfirm}
      {...rest}
    />
  );
};

export default EnableTextNotifications;
